let runInterval = true
function handleThumbs(e) {
    if(e){
    	runInterval = false
    }
    let galleryValues = document.querySelector('.product-gallery').getBoundingClientRect()
    let header = document.querySelector('#header').getBoundingClientRect()
    if((galleryValues.height+galleryValues.top)<window.innerHeight){
       $('.thumbs-wrapper').css('bottom', 20 + 'px')
    }else{
      if (galleryValues.bottom > (galleryValues.height - $('.thumbs-wrapper').height()/2)) {
          let topPos = galleryValues.bottom - window.innerHeight + 20
          $('.thumbs-wrapper').css('bottom', topPos)
      } else {
          $('.thumbs-wrapper').css('bottom', 20 + 'px')
      }
    }
}

$(document).ready(function() {
    var windowHeight = $(window).height();
    let thumbWrapper = $('#shopify-section-product .thumbs-wrapper')
    if (thumbWrapper.length && thumbWrapper.css('display') != 'none') {
        $(window).scroll(handleThumbs);
      let interval = setInterval(function(){
        if(runInterval==false){
        	clearInterval(interval)
        }
        handleThumbs()
      },300)
        
    }
  $(".product_accordians .tabs").each(function(){
    var trigger= $(this).find('button.accordion')
    var siblings = $(this).siblings()
    var acc_text = $(this).find('.panel')
    $(trigger).click(function(){
       //$('.product_accordians .tabs button.accordion').removeClass('active');
      $(this).toggleClass('active');
     
       
        var visible_text = siblings.find('.panel').filter(":visible")
        $(acc_text).slideToggle()
       $(visible_text).slideUp()
       $(visible_text).parents('.tabs').find('button').removeClass('active');
       
    });
});
//  $(".pdp-btn-price #product-wrap .swatch .swatch-element").each(function(){
//     $(this).on("click", function(){
//       var dataprice = $(this).attr("data-price");
//       console.log(dataprice);
//       $(".price-change").html(dataprice);
//     });
//   });
    $(".pdp-btn-price #product-wrap .swatch .swatch-element-price").on("click", function(){
      var dataprice = $(this).attr("data-price");
      console.log(dataprice);
      $(".price-change").html(dataprice);
    });  
});



if (navigator.appVersion.indexOf("Win")!=-1) 
{
  $("body").addClass("Windows");
}
if (navigator.appVersion.indexOf("Mac")!=-1) 
{
  $("body").addClass("Mac");
}
if (navigator.appVersion.indexOf("X11")!=-1) 
{
  $("body").addClass("UNIX");
}
if (navigator.appVersion.indexOf("Linux")!=-1) 
{
  $("body").addClass("Linux");
}


